import { render, staticRenderFns } from "./Appraisals.vue?vue&type=template&id=c03b3bd2&"
import script from "./Appraisals.vue?vue&type=script&lang=ts&"
export * from "./Appraisals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports